const fallbackConfig = {
    amountResults: [10, 25, 50],
    defaultPerPageResults: 25
};

module.exports = fallbackConfig;


// WEBPACK FOOTER //
// ./app/fallbackConfig.js